import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { FC } from 'react'
import CommitteeForm from '../../component/web/committees/CommitteeForm'
import useTranslate from '../../i18n/useTranslate'
import useCheckPermission from '../../utilities/checkPermission'

const CommitteeEdit: FC<{}> = () => {
    const translate = useTranslate()
    const checkPermissionHook = useCheckPermission()
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                {translate.get('LABEL.ADD_EXPERTISE_INFO')}
            </Typography>
            <pre />
            <CommitteeForm isReadOnly={checkPermissionHook.isUserChairman()} />
        </Container>
    )
}

export default CommitteeEdit
